/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetFilePathParameters } from 'api/actions/get-file/get-file-path-parameters';
import { GetFileResponse } from 'api/actions/get-file/get-file-response';

type GetFileQueryParameters = Record<string, any>;

/**
 * The path of the GetFile action.
 */
export const getFileActionPath = new SweetPath<keyof GetFilePathParameters>('/files/{publicId}', { path: '{param}' });

/**
 * Creates a contextualized GetFile actions.
 */
export default function createGetFileAction(axios: AxiosInstance) {
  return function getFileAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetFilePathParameters;
    query?: GetFileQueryParameters;
  }) {
    const path = getFileActionPath.insert(parameters);

    return axios.get<GetFileResponse, GetFileResponse>(path, { params: query, headers });
  };
}
